import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Mail, ArrowRight } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { IMAGES } from "../data/site";

function formatApiErrorDetail(detail) {
  if (detail == null) return "Något gick fel. Försök igen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : "")).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Inloggad!");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Inloggning misslyckades");
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full rounded-xl bg-slate-50 border border-slate-200 p-4 pl-11 focus:ring-2 focus:ring-brand-accent focus:border-transparent focus:outline-none transition-all";

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-tint px-5" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-3xl p-8 md:p-10 border border-slate-100 shadow-[0_20px_50px_rgba(10,37,64,0.08)]">
          <div className="flex justify-center">
            <img src={IMAGES.logo} alt="Se Klart Ut" className="h-14 w-auto object-contain" />
          </div>
          <h1 className="mt-6 text-2xl font-semibold text-brand-navy text-center">Admin-inloggning</h1>
          <p className="mt-2 text-slate-500 text-center text-sm">Logga in för att se inkomna offertförfrågningar.</p>
          <form onSubmit={submit} data-testid="admin-login-form" className="mt-8 space-y-4">
            <div className="relative">
              <Mail className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
              <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" className={inputCls} placeholder="E-post" />
            </div>
            <div className="relative">
              <Lock className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
              <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" className={inputCls} placeholder="Lösenord" />
            </div>
            <button type="submit" disabled={loading} data-testid="admin-login-button" className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-brand-accent text-white font-medium px-8 py-4 hover:bg-brand-accentHover disabled:opacity-60 transition-colors">
              {loading ? "Loggar in…" : <>Logga in <ArrowRight className="h-4 w-4" /></>}
            </button>
          </form>
        </div>
        <button onClick={() => navigate("/")} className="mt-6 w-full text-center text-sm text-slate-500 hover:text-brand-accent transition-colors">
          ← Tillbaka till webbplatsen
        </button>
      </div>
    </div>
  );
}
